module.exports = __webpack_public_path__ + "static/media/twentyappearances.662794fc.jpg";